import React, {useEffect,useMemo, useState,useRef } from 'react';
import {useHistory, useLocation} from 'react-router-dom';

import {useFetch, useModal, useToast} from 'helpers/hooks';
import {ActionButton} from 'components/ActionButton';
import {DocumentsTable} from 'components/DocumentsTable';
import {FileModal} from 'components/FileModal';
import {FilePreview} from 'components/FilePreview';
import {FilterBar} from 'components/FilterBar';
import {MobileFilterBar} from 'components/MobileFilterBar';
import {FilterButtons} from 'components/FilterButtons';
import {Pagination} from 'components/Pagination';
import {ProgressSpinner} from 'components/ProgressSpinner';
import {RejectModal} from 'components/RejectModal';
import {DirectRejectModal} from 'components/DirectRejectModal';
import {RemoveModal} from 'components/RemoveModal';
import {ArchiveModal} from 'components/ArchiveModal';
import {TemplateModal} from 'components/TemplateModal';
import {MergeModal} from 'components/MergeModal';
import {RemoveAssignedModal} from 'components/RemoveAssignedModal';
import {Button} from 'components/Button';
import {SearchBar} from 'components/SearchBar';
import styles from 'css_modules/DocumentList.module.css';
import {CaptureButton} from "./CaptureButton";
import {CaptureModal} from "./CaptureModal";
import {request} from "../helpers/tools";
import {DuplicateSModal} from "./DuplicateSModal";
import {ExportTableModal} from "./ExportTableModal";
import {TableSettingsModal} from "./TableSettingsModal";
import {NotificationLogo} from 'components/NotificationLogo'
import {ReactComponent as Wheel} from 'assets/svg/2_wheel.svg';
import Split from '@uiw/react-split';
import { DetailBulkModifyButton } from './DetailBulkModifyButton';
import { BulkRemoveButton } from './BulkRemoveButton';
import {ReactComponent as Arrow} from 'assets/svg/2_arrow_left.svg';
import {ReactComponent as ChevronLeft} from 'assets/svg/2_chevron_left.svg';
import {ReactComponent as ChevronRight} from 'assets/svg/2_chevron_right.svg';
import { ShareModal } from 'components/ShareModal';

export const DocumentList = ({page, setPage, activeOnlyFilter, setActiveOnlyFilter, heading, permissions, user, accountingYears, clientCompanies,
     activities, centres, contracts, docTypes, numSeries, accountCode, vatClassification, vatKvClassification, accounts, countries, currencies,
      taxRates, paymentTypes, filter, setFilter, limit, setLimit, focusedDocId, setFocusedDocId,setShowNotifications, isMobile,onMenuClick}) => {
    let docs  = {"data":{"results":[]}}
    sessionStorage.setItem("accountingYears", JSON.stringify(accountingYears))
    const availableYears = [...new Set(accountingYears.map((accountingYear) => accountingYear.year))]
    .sort()
    .reverse();
    
    const [shareDoc, setShareDoc] = useState(null);
    const [readyToFetch, setReadyToFetch] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [actionsOpen, setActionsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [isSnappedRight, setIsSnappedRight] = useState(false);
    const toggleSnapPane = () => {
        if (isSnappedRight) {
            prevPane = parseFloat(sessionStorage.getItem("prevPane" + user.pk)) || 80;
            setIsSnappedRight(false);
        } else {
            prevPane = 100;
            setIsSnappedRight(true);
        }
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setActionsOpen(false);
            }
        };

        if (actionsOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [actionsOpen]);


    const [tableSettingsModal, toggleTableSettingsModal] = useModal();

    

    useEffect(() => {
      const resizeHandler = () => {
        if (windowWidth!==window.innerWidth){ setWindowWidth(window.innerWidth);
            
        }
      };
      
      window.addEventListener('resize', resizeHandler);
  
      return () => {
        window.removeEventListener('resize', resizeHandler);
      };
    }); 

    const divRef = useRef(null);
    const [leftPaneWidth, setLeftPaneWidth] = useState(null);

    useEffect(() => {
        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                const { width } = entry.contentRect;
                const widthInEm = width / 20;

                if (leftPaneWidth!==widthInEm){
                    setLeftPaneWidth(widthInEm)
                    if (widthInEm > 54) {
                       // setButtonsStyle(styles.buttons);        
                    } else {
                       // setButtonsStyle(location.pathname !== '/archive'? styles.buttonsNarrow : styles.buttonsNarrow);        
                    }
                }
            }
        });
    
        const currentDivRef = divRef.current;
    
        if (currentDivRef) {
            observer.observe(currentDivRef);
        }
    
        return () => {
            if (currentDivRef) {
                observer.unobserve(currentDivRef);
            }
        };
    });

    
    let prevPane = parseFloat(sessionStorage.getItem("prevPane"+user.pk))
    
    if (prevPane!==undefined && !isNaN(prevPane)){  }
    else{   prevPane=80  }

    const showToast = useToast();
    let [ordering, setOrdering] = useState('');
    const [paged, setPaged] = useState(page);
    const [search, setSearch] = useState('start');
    const [searching, setSearching] = useState(false);
    const [docsList, setDocsList] = useState([])
    const [lastDocs, setLastDocs] = useState({})
    const location = useLocation();
    const [cursor, setCursor] = useState("");
    const [clicked, setClicked] = useState("")
    const paginationRef = useRef({
            next: "",
            previous: "",
            clicked: ""
        });
    
    if (search==="start"){setSearch("")}
    
    const getBackupStateData = () => {
        const storedCheckedDoc = localStorage.getItem('storedCheckedDoc'+location.pathname);
        if (storedCheckedDoc && storedCheckedDoc!=="" && storedCheckedDoc!==undefined  ){
            setFocusedDocId(storedCheckedDoc)
        } 
    };
    getBackupStateData()
        
    const [mainChecked, setMainChecked] = useState(false);
    const [multiDuplicates, setMultiDuplicates] = useState([]);
    //const [refreshInterval] = useState(300000);
    
    
    const isStaticPage =
        location.pathname === '/archive' ||
        location.pathname === '/my_templates';

    const refreshInterval = isStaticPage ? 10e12 : 100000; 
    

    const [checkedDocs, setCheckedDocs] = useState([]);
    const isOrgUnitAdmin = user.role === "OrganizationUnitAdmin";
    const history = useHistory();
    
    const [exportTableModal, toggleTableExportModal] = useModal();
    const closeExportTableModal = () => {
        toggleTableExportModal()
    }
    function handleExport () {
        toggleTableExportModal()
    }
   
    

    const canExport = true

    if (ordering !==''){
       sessionStorage.setItem("ordering"+location.pathname, ordering);
    }

    let savedOrdering = sessionStorage.getItem("ordering"+location.pathname)
    if (ordering === '' &&  savedOrdering!==null){
        if (ordering!==savedOrdering){
            setOrdering(savedOrdering)
        }
    }
        
        
    const mandatoryAccountingYear = () => {
        const myVisibleFields = [...visibleFields];

        if (!myVisibleFields.includes('default.accounting_year')) {
            myVisibleFields.splice(1, 0, 'default.accounting_year');
        }

        return myVisibleFields;
    };
   
    const handleResize = (preSize, nextSize, paneNumber) => {
        //console.log(`Drag ended. Previous size: ${preSize}, Next size: ${nextSize}, Pane number: ${paneNumber}`);
        sessionStorage.setItem("prevPane"+user.pk, nextSize);
      };
    

    useEffect(()=>{
        setPage(paged)
        
    }, [paged, setPage])

    const ormFormat = (str) => {
        let ormFormatedStr = str.replace("document_info", 'info').replace('.', '__');
        if(str === 'note'){
            ormFormatedStr = 'info__note';
        }
        if(ormFormatedStr.startsWith('state')){
            ormFormatedStr = 'state';
        }
        
        return ormFormatedStr;
    }
   
    sessionStorage.setItem("currentPage", ordering);
    

    const getFilter = () => {
        let filterData = [];
        Object.keys(filter).forEach(key => {
            if ( ormFormat(key) === 'accounting_year' && parseInt(filter[key])===-1 ){}
            else{
                if (ormFormat(key)==='document_type' && parseInt(filter[key])){
                    filterData.push(ormFormat(key) + '=rzn')
                    filterData.push("document_user_created_type="+String(filter[key]) )
                }
                else if (ormFormat(key)==='info__total_from' || ormFormat(key)==='info__total_to' ||
                         ormFormat(key)==='info__tax_value_from' || ormFormat(key)==='info__tax_value_to' ||
                         ormFormat(key)==='info__value_original_from' || ormFormat(key)==='info__value_original_to'){
                    filterData.push(ormFormat(key) + '=' + filter[key].replace(',', '.'))
                }
                else{
                    filterData.push(ormFormat(key) + '=' + filter[key])
                }
             }
        });
        if (!('accounting_year' in filter) && location.pathname === '/archive') {
          filterData.push(ormFormat("accounting_year") + '=' + availableYears[0])
        }
        return '&' + filterData.join('&')
    }
    
    
    let currFilter = getFilter();

    const fetchUrl = useMemo(() => {
        return `${location.pathname}/?search=${search}` +
            `&location=${location.pathname.slice(1)}` +
            `&active_only=${activeOnlyFilter ?? false}` +
            `&ordering=${ordering}` +
            `&page=${page}` +
            `&limit=${limit}` +
            `${currFilter !== '&none=' ? currFilter : ''}` +
            `${cursor ? `&cursor=${cursor}` : ''}`;
    }, [
        location.pathname,
        search,
        activeOnlyFilter,
        ordering,
        page,
        limit,
        currFilter,
        cursor
    ]);

    useEffect(() => {
        if (!clicked.includes("clicked")) return;
        if (clicked.includes("next")) {
            setCursor(paginationRef.current.next);
            setPage(p => p + 1);
        } else if (clicked.includes("previous")) {
            setCursor(paginationRef.current.previous);
            setPage(p => p - 1);
        }
        else if (clicked.includes("reset")) {
            setCursor("");
            setPage(1);
        }

        setClicked("");
    }, [clicked,setPage]);
    
    const response = useFetch(readyToFetch ? fetchUrl : null, null);
    
    docs = {"data":{"results":[]}}
    
    let searchString = `search=${search}` +
                        `&location=${location.pathname.slice(1)}` +
                        `&active_only=${activeOnlyFilter === undefined ? false : activeOnlyFilter}` +
                        `&ordering=${ordering}` +
                        `&page=${page}` +
                        `&limit=${limit}` +
                        `${(currFilter !== '&none=' )? currFilter : ""}`;

    let paramsSearched = "";
    let paramsGot = "";
    //let lastParams = normalizeParams(lastDocs?.data?.filter)
    
    const normalizeParams = (input) => {
        const params = new URLSearchParams(input);

        params.delete("cursor");

        const map = new Map();

        for (const [key, value] of params.entries()) {
            
            const cleanedValue = value.replace(/[/\\]/g, "")
            map.set(key, cleanedValue);
        }

        return Array.from(map.entries())
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([k, v]) => `${k}=${v}`)
            .join("&");
    };

    if (response.data) {
        paramsSearched = normalizeParams(response.data.filter);
        paramsGot = normalizeParams(searchString);
        
        console.log("\n\nResponse came for filter:");
        console.log(paramsSearched);

        console.log("Requested filter by frontend:");
        console.log(paramsGot);

        console.log("Desired data:", paramsSearched === paramsGot);
    }
    
    if (response.data && paramsSearched === paramsGot ){
        docs = response
        if (JSON.stringify(docs)!== JSON.stringify(lastDocs)){
            setLastDocs(response)
            if (searching === true){setSearching(false)}  
        }

        let newNextCursor =  response.data.next
        ? new URL(response.data.next).searchParams.get("cursor")
        : null;
        let newPreviousCursor =  response.data.previous
        ? new URL(response.data.previous).searchParams.get("cursor")
        : null;
        paginationRef.current.next=newNextCursor
        paginationRef.current.previous=newPreviousCursor
        
    }
    else if (lastDocs?.data?.filter === searchString){ 
        console.log("Avoiding inappropriate data.")
        docs = lastDocs
        if (searching === true){setSearching(false)}    
    }
    else if (searching === false){
        setSearching(true)
        //
    }
  
    
    if (docs.data){
        if (docs.data.searched === search){
            let list = []
            for (let i=0; i<docs.data?.results.length; i++){
                let el = docs.data?.results[i]
                list.push(el.uuid)
            }
            if (JSON.stringify(docsList)!==JSON.stringify(list)){
                setDocsList(list)
            }
        }
    }
   

    const cstmDocTypes = useFetch('/document_client_company_created_custom_types/', []);

    if (cstmDocTypes.data && cstmDocTypes.data.length>0) {
        let div = {"name":"------", slug:"",disabled:"true"}
        if (!JSON.stringify(docTypes).includes(JSON.stringify(div))){
        // docTypes.splice( docTypes.length-1, 0, div )
        }
                
        cstmDocTypes.data.forEach( e => {
            let t = {}
            t["id"]=e["id"]
            t["name"]=e["name"]
            t["slug"]=e["id"]
            
            if (!JSON.stringify(docTypes).includes(JSON.stringify(t))){
                docTypes.push(t)
            }
        })
    }
    

    const cstmDocTypesparsed =  docs.data.results
            .filter(doc => doc.custom_type && doc.custom_type.length > 0) 
            .map(doc => ({
            document: doc.uuid,
            user_types: doc.custom_type,
            }))

    cstmDocTypes.data = cstmDocTypesparsed
    
        
    
    sessionStorage.setItem("docsList",docsList.join(',') );
    
    const [viewModal, toggleView] = useModal();
    const [rejectModal, toggleRejectModal] = useModal();
    const [directRejectModal, toggleDirectReject] = useModal();
    const [removeModal, toggleRemove] = useModal();
    const [archiveModal, toggleArchive] = useModal();
    const [templateModal, toggleTemplate] = useModal();
    const [mergeModal, toggleMerge] = useModal();
    const [unassignModal, toggleUnassign] = useModal();
    const [captureModal, toggleCapture] = useModal();

    
    function toggleReject  (doc) {
        if (user.direct_reject) {
            toggleDirectReject();
        } else {
            toggleRejectModal();
        }
    };
    
    const focusedDoc = docs.data?.results?.find(doc => doc.uuid === focusedDocId);
    const visibleState = location.pathname !== '/documents' && user?.role !== 'MaintenanceUser';
    const checkedDocsAsObjects = docs.data?.results.filter((doc) => checkedDocs.includes(doc.uuid));

    const fields = {
        default: {
            name: 'Obecné',
            items: {
                uuid: {
                    name: 'uuid',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                platform: {
                    name: 'Zdroj',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                name: {
                    name: 'Název souboru',
                    type: 'string',
                    class: 'textCell',
                    width: '1fr'
                },
                last_modified: {
                    name: 'Změněno',
                    type: 'date',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.edited_by': {
                    name: 'Změnil',
                    type: 'string',
                    class: 'by',
                    width: '1fr'
                },
                added_by: {
                    name: 'Autor',
                    type: 'string',
                    class: 'by',
                    width: '1fr'
                },
                document_type: {
                    name: 'Typ',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'state.title': {
                    name: 'Stav',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                note: {
                    name: 'Poznámka',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                external_id: {
                    name: 'Číslo v účetním systému',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.currency_title': {
                    name: 'Měna',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                client_company: {
                    name: 'Klientská společnost',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.document_identifier': {
                    name: 'Popis dokladu',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.number': {
                    name: 'Číslo dokladu',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.date': {
                    name: 'Datum',
                    type: 'date',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.taxable_supply_date': {
                    name: 'Datum zdanitelného plnění',
                    type: 'date',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.due_date': {
                    name: 'Datum splatnosti',
                    type: 'date',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.accounting_date': {
                    name: 'Datum účetního případu',
                    type: 'date',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.tax_deduction_date': {
                    name: 'Datum odpočtu',
                    type: 'date',
                    class: 'greyText',
                    width: '1fr'
                },
                accounting_year: {
                    name: 'Účetní rok',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.activity_title': {
                    name: 'Činnost',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.activity_code': {
                    name: 'Kód činnosti',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.centre_title': {
                    name: 'Středisko',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.centre_code': {
                    name: 'Kód střediska',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.contract_title': {
                    name: 'Zakázka',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.contract_number': {
                    name: 'Číslo zakázky',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
            }
        },
        partner: {
            name: 'Partner',
            items: {
                'document_info.supplier_identification_number': {
                    name: 'IČ',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.supplier_vat': {
                    name: 'DIČ',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.supplier_title': {
                    name: 'Název partnera',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.supplier_street': {
                    name: 'Ulice',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.supplier_city': {
                    name: 'Město',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.supplier_zip_code': {
                    name: 'PSČ',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.supplier_country': {
                    name: 'Země',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
            }
        },
        payment: {
            name: 'Platba',
            items: {
                'document_info.payment_type_title': {
                    name: 'Forma úhrady',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.supplier_account_number': {
                    name: 'Číslo účtu',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.supplier_bank_code': {
                    name: 'Kód banky',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.variable_symbol': {
                    name: 'Variabilní symbol',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.payment_date': {
                    name: 'Datum úhrady',
                    type: 'date',
                    class: 'greyText',
                    width: '1fr'
                },
            }
        },
        costs: {
            name: 'Náklady',
            items: {
                'document_info.total': {
                    name: 'Celková částka',
                    type: 'price',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.tax_value': {
                    name: 'DPH',
                    type: 'dph',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.value_original': {
                    name: 'Základ bez DPH',
                    type: 'price',
                    class: 'greyText',
                    width: '1fr'
                },
            }
        },
        accounting: {
            name: 'Účtování',
            items: {
                'document_info.num_series_title': {
                    name: 'Číselná řada',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.account_code_title': {
                    name: 'Předkontace',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.vat_classification_title': {
                    name: 'Členění DPH',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.vat_kv_classification_title': {
                    name: 'Členění KV DPH',
                    type: 'select',
                    class: 'greyText',
                    width: '1fr'
                },
                'document_info.reverse_charge': {
                    name: 'Přenesená daňová povinnost',
                    type: 'bool',
                    class: 'greyText',
                    width: '1fr'
                },
            }
        }
    };

        
    if (location.pathname === '/my_templates') {
        fields.template = {
            name: 'Šablona',
            items: {
                'document_info.template_name': {
                    name: 'Název šablony',
                    type: 'string',
                    class: 'greyText',
                    width: '1fr'
                }
            }
        };
        if( user && user.search_fields && !user.search_fields.includes("template.document_info.template_name")){
            user.search_fields.unshift("template.document_info.template_name");
        }
        
        /*
        delete fields.default.items["document_info.date"]
        delete fields.default.items["document_info.taxable_supply_date"]
        delete fields.default.items["document_info.due_date"]
        delete fields.default.items["document_info.accounting_date"]
        delete fields.default.items["document_info.tax_deduction_date"]
        delete fields.payment.items["document_info.payment_date"]
        */
        
         if( user && user.search_fields){
              //user.search_fields = user.search_fields.filter(item => !item.includes("date"));
              user.search_fields = user.search_fields.filter(f => f !== 'default.state.title')
         }
         
    }
    else{
        if ( user && user.search_fields && user.search_fields.indexOf("template.document_info.template_name") !== -1) {
            user.search_fields.splice(user.search_fields.indexOf("template.document_info.template_name"), 1);
        }

        if (user && user.search_fields) {
            user.search_fields = user.search_fields.filter(
                item => item !== "default.state.title"
            );
             user.search_fields = [
            'default.state.title',
            ...user.search_fields.filter(f => f !== 'default.state.title')
            ];
        }
    }
    const defaultFields = [
        'default.name',
        'default.last_modified',
        'default.added_by',
        'default.document_type',
        'default.state.title',
        'default.note',
    ];

    
    const repairRelocatedFields = () => {
        for (var i = 0; i < user.search_fields.length; i++) {
            if (user.search_fields[i]==='default.document_info.total'){
                user.search_fields[i]='costs.document_info.total';
            }
            if (user.search_fields[i]==='default.UUID'){
                user.search_fields[i]='default.uuid';
            }
            if (user.search_fields[i]==='default.document_info.tax_value'){
                user.search_fields[i]='costs.document_info.tax_value';
            }
            if (user.search_fields[i]==='default.document_info.value_original'){
                user.search_fields[i]='costs.document_info.value_original';
            }
            if (user.search_fields[i]==='accounting.document_info.account_code'){
                user.search_fields[i]='accounting.document_info.account_code_title';
            }
            if (user.search_fields[i]==='default.document_info.accounting_event_date'){
                user.search_fields[i]='default.document_info.accounting_date';
            }
            if (user.search_fields[i]==='accounting.document_info.num_series_title'){
                user.search_fields[i]='accounting.document_info.num_series';
            }
            if (user.search_fields[i]==='accounting.document_info.num_series'){
                user.search_fields[i]='accounting.document_info.num_series_title';
            }
        } 
    }
    if (user.search_fields != null){
        repairRelocatedFields();
    }
    
   
    
    
    let [activeFields, setActiveFields] = useState(user.search_fields ? user.search_fields : defaultFields);
    let [visibleFields, setVisibleFields] = useState(user.search_fields ? user.search_fields : defaultFields);
    let filterVisibleFields = mandatoryAccountingYear();
    

    
    if (location.pathname !== '/my_templates')
    {
        if (visibleFields.includes("template.document_info.template_name")){
            setVisibleFields(visibleFields.filter(item => item !== "template.document_info.template_name"))
        }
        if (activeFields.includes("template.document_info.template_name")){
            setActiveFields(activeFields.filter(item => item !== "template.document_info.template_name"))
        }
    }
    
    if(location.pathname === '/my_templates' && (!visibleFields.includes("template.document_info.template_name") || !activeFields.includes("template.document_info.template_name"))){
        let intVisFields = JSON.parse(JSON.stringify(visibleFields))
        intVisFields.unshift("template.document_info.template_name")
        setVisibleFields(intVisFields)
        setActiveFields(intVisFields)
    }

    if(location.pathname === '/my_templates'){
        let intVisFields = JSON.parse(JSON.stringify(visibleFields))
        //intVisFields = intVisFields.filter(field => !field.includes("date"));
        intVisFields= intVisFields.filter(f => f !== 'default.state.title')
        if (JSON.stringify(intVisFields)!==JSON.stringify(visibleFields)){
            setVisibleFields(intVisFields)
            setActiveFields(intVisFields)
        }
    }else{
        let intVisFields = JSON.parse(JSON.stringify(visibleFields))
        //intVisFields = intVisFields.filter(field => !field.includes("date"));
        intVisFields = [
            'default.state.title',
            ...intVisFields.filter(f => f !== 'default.state.title')
            ];
        if (JSON.stringify(intVisFields)!==JSON.stringify(visibleFields)){
            setVisibleFields(intVisFields)
            setActiveFields(intVisFields)
        }
    }
    

    const update = () => {
        docs.fetchData();
        setFocusedDocId(null);
    }
    const fullUpdate = () => {
        docs.fetchData();
        setMainChecked(false);
        setCheckedDocs([]);
    }

    const actionButtonProps = {
        canEdit: user.can_edit,
        forward: location.pathname === '/my_documents',
        data: checkedDocsAsObjects,
        user: user,
        update: () => {
            if (location.pathname === '/my_documents') {
                fullUpdate();
            }
        }
    };

    const saveTableSettings = async () => {
        await request(`/search_fields/upload/`, 'POST', activeFields);
        showToast('Nastavení sloupců bylo uloženo');
        setVisibleFields(activeFields);
        user.search_fields = activeFields;
    }
    
    
    useEffect(() => { // reset states on route change
            const unsubscribe = history.listen((newLocation) => {
                const nextIsList = ['/documents', '/my_documents', '/archive', '/my_templates'].includes(newLocation.pathname);
                if (nextIsList) {
                    if (newLocation.pathname !== location.pathname) {
                        try{
                            docs.setData(null);
                        }
                        catch{

                        }
                        console.log("Going to "+newLocation.pathname +" from "+ location.pathname)
                        if (location.pathname.includes('my_documents')){
                            localStorage.setItem("myDocumentsSearchString"+user.pk+user.role, "")
                        }
                        else if (location.pathname.includes('documents')){
                            localStorage.setItem("documentsSearchString"+user.pk+user.role, "")
                        }
                        else if (location.pathname.includes('archive')){
                            localStorage.setItem("archiveSearchString"+user.pk+user.role, "")
                        }
                        else if (location.pathname.includes('templates')){
                            localStorage.setItem("templatesSearchString"+user.pk+user.role, "")
                        }
                        

                        setPage(1);
                        setPaged(1);
                        setSearch("start")
                        setLastDocs({})
                    }

                  
                    
                    setMainChecked(false);
                    setCheckedDocs([]);
                    setFocusedDocId(null);
                    setOrdering('');
                    //setSearch('');
                    setFilter({'none':''});
                    setActiveFields(user.search_fields ? user.search_fields : defaultFields);
                    setVisibleFields(user.search_fields ? user.search_fields : defaultFields);

                }
            });
            return () => unsubscribe()
        // eslint-disable-next-line
        }, [docs, history, location.pathname, setPage, setPaged]
    );
    

    const fetchMetrics = React.useCallback(() => {
        response.fetchData();
        setMainChecked(false);
        setCheckedDocs([]);
        // eslint-disable-next-line
    }, [docs]);

    useEffect(() => {
        if (refreshInterval && refreshInterval > 0) {
            const interval = setInterval(fetchMetrics, refreshInterval);
            return () => clearInterval(interval);
        }
    }, [refreshInterval, fetchMetrics]);

    useEffect(() => { // check and focus previously viewed
        if (location.state) {
            setFocusedDocId(location.state.focusedDocId);
        }
        // eslint-disable-next-line
    }, [location.state]);

    const exportXLSX = () => {
        //prepare data
        if  (checkedDocsAsObjects.length===0){
            showToast('Vyberte doklady pro export.')
        }
        else{
            handleExport()
        }
    }

    //let templates = useFetch('/document_template/', []);
   
    
    const saveAndCloseTableSettingsModal = () => {
        toggleTableSettingsModal();
        saveTableSettings();
    }


    
 
    let minWidthLeft =  Math.max(activeFields.length * 5.5, 38)
    

    // ===== Flags =====
    const isTemplates = location.pathname === "/my_templates";
    const isDocuments = location.pathname === "/my_documents";
    const isArchive = location.pathname === "/archive";
    const isDesktop = windowWidth > 1224;

    // ===== Shared Props =====
    const filterBarProps = {
        filter,
        setFilter,
        docs: docs.data.results,
        role: user.role,
        accountingYears,
        clientCompanies,
        activities,
        centres,
        contracts,
        docTypes,
        numSeries,
        accountCode,
        vatClassification,
        vatKvClassification,
        accounts,
        countries,
        currencies,
        taxRates,
        paymentTypes,
        fields,
        visibleFields: filterVisibleFields,
        checkedDocs,
        setCheckedDocs,
        focusedDocId,
        setFocusedDocId,
        user,
        setPage,
    };

    
    const tableProps = {
        docs: docs.data.results,
        setOrdering,
        focusedDocId,
        checkedDocs,
        setCheckedDocs,
        setFocusedDocId,
        mainChecked,
        visibleState,
        setMainChecked,
        toggleReject,
        toggleRemove,
        toggleMerge,
        toggleArchive,
        toggleTemplate,
        toggleView,
        toggleUnassign,
        permissions,
        user,
        toggleCapture,
        fields,
        visibleFields,
        loading: searching,
        ordering,
        docsCustomTypes: cstmDocTypes,
        isSnappedRight,
    };

    // ===== Top Buttons =====
    const topButtons = (
        <div className={styles.topRowButtons}>
            <div className={styles.leftButtons}>
                {isTemplates ? (
                    <DetailBulkModifyButton docs={checkedDocsAsObjects}/>
                ) : (
                    isDocuments && (
                        <FilterButtons
                            activeOnly={activeOnlyFilter}
                            setActiveOnly={setActiveOnlyFilter}
                            user={user}
                        />
                    )
                )}
            </div>

            { (
                <div className={styles.rightButtons}>
                    {isDocuments && (
                        <BulkRemoveButton
                            docs={checkedDocsAsObjects}
                            toggleRemove={toggleRemove}
                        />
                    )}

                   <div
                        ref={dropdownRef}
                        className={`${styles.dropdownWrapper} ${actionsOpen ? styles.open : ""}`}
                    >

                        <div className={styles.dropdownContainer}>

                            <Button
                                className={`${styles.secondaryButton} ${styles.actionButton}`}
                                onClick={() => setActionsOpen(o => !o)}
                            >
                                <Wheel className={`${styles.wheelIcon} ${actionsOpen ? styles.wheelOpen : ""}`} />
                                Nastavení
                                <span
                                    style={{ marginLeft: "0.6rem", marginRight: "-0.5rem" }}
                                    className={`${styles.chevron} }`}
                                >
                                   {!actionsOpen && <ChevronLeft/>} 
                                   {actionsOpen && <ChevronRight/>} 
                                </span>
                            </Button>

                            <div
                                className={`${styles.dropdownMenu} ${actionsOpen ? styles.open : ""}`}
                                onClick={() => setActionsOpen(false)}
                            >
                                <Button
                                    className={styles.dropdownItem}
                                    onClick={toggleTableSettingsModal}
                                >
                                    Nastavení sloupců
                                </Button>

                             

                                {canExport && isArchive && !isTemplates && (
                                    <Button
                                        className={styles.dropdownItem}
                                        onClick={exportXLSX}
                                    >
                                        Export
                                    </Button>
                                )}

                                {isDocuments && (
                                    <DetailBulkModifyButton
                                        className={styles.dropdownItem}
                                        docs={checkedDocsAsObjects}
                                    />
                                )}
                            </div>

                        </div>

                        {user.uses_ocr && isDocuments && (
                            <CaptureButton
                                className={styles.captureButton}
                                docs={checkedDocsAsObjects}
                                update={fullUpdate}
                            />
                        )}

                        {!isArchive && !isTemplates && !isOrgUnitAdmin && (
                            <ActionButton
                                className={styles.actionButton}
                                {...actionButtonProps}
                                duplicates={multiDuplicates}
                                update={fullUpdate}
                                setDuplicates={setMultiDuplicates}
                            />
                        )}

                    </div>

                </div>
            )}
        </div>
    );

    // ===== Table Block =====
    const tableBlock = (
        <div className={styles.tableContainer}>
            {topButtons}
            <DocumentsTable {...tableProps} />
            <div className={styles.footer}>
                <Pagination
                    user={user}
                    docs={docs.data}
                    setPage={setPaged}
                    limit={limit}
                    setLimit={setLimit}
                    setClicked={setClicked}
                    canPrev={paginationRef.current.previous!==null}
                    canNext={paginationRef.current.next!==null}
                />
            </div>
        </div>
    );

    useEffect(() => {
        if (user && accountingYears?.length && filter) {
            setReadyToFetch(true);
        }
    }, [user, accountingYears, filter]);
    // ===== Return =====
    if (searching === true) {
        
        return (
            <div className={styles.wrap}>

                <header className={styles.topRow}>
                    
                <div className={styles.heading}>
                        {isMobile && (
                        <button 
                            onClick={onMenuClick} 
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                marginRight: "1rem",
                                marginBottom: "-1rem",
                                width: '28px',
                                height: '28px'
                            }}
                            aria-label="Open navigation menu"
                        >
                            <svg 
                                width="24" 
                                height="24" 
                                viewBox="0 0 24 24" 
                                fill="none" 
                                stroke="var(--primary, #007bff)" 
                                strokeWidth="2.5" 
                                strokeLinecap="round" 
                                strokeLinejoin="round"
                            >
                                <line x1="3" y1="12" x2="21" y2="12"></line>
                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                <line x1="3" y1="18" x2="21" y2="18"></line>
                            </svg>
                        </button>
                    )}

                     {heading}
                </div>

                <div className={styles.searchBar}>
                    <SearchBar
                    search={search}
                    setPage={setPage}
                    setSearch={setSearch}
                    />
                </div>

                { (
                    <NotificationLogo
                    user={user.pk}
                    display={user.display_notifications}
                    notifications={user.notifications}
                    setShowNotifications={setShowNotifications}
                    />
                )}

                
            </header>
            
            {!isMobile &&(<FilterBar {...filterBarProps} />)}
            {isMobile &&(<MobileFilterBar {...filterBarProps} />)}
            

              <section className={styles.main}>
                        {isTemplates ? (
                            <div 
                                className={styles.scrollable} 
                                style={{ marginRight: "0.5rem" }}
                                >
                                {tableBlock}
                            </div>
                        ) : isDesktop ? (
                            <Split
                            onDragEnd={handleResize}
                        renderBar={({ onMouseDown, ...props }) => (
                <div
                    {...props}
                    onMouseDown={onMouseDown}
                    style={{
                    width: "0.6rem",
                    height: "100%",
                    backgroundColor: "var(--semilight)",
                    cursor: "col-resize",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    zIndex: 70, 
                    }}
                >
                    <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "2px",
                        height: "100%",
                    }}
                    >
                    <span
                        style={{
                        width: "2px",
                        height: "3rem",
                        backgroundColor: "var(--purple)",
                        borderRadius: "2px",
                        pointerEvents: 'none',
                        }}
                    />
                    <span
                        style={{
                        width: "2px",
                        height: "3rem",
                        backgroundColor: "var(--purple)",
                        borderRadius: "2px",
                        pointerEvents: 'none',
                        }}
                    />
                    </div>
                    <button
                        onClick={toggleSnapPane}
                        style={{
                            position: "absolute",
                            top: "1.2rem",
                            left: isSnappedRight ? "0" : "100%",
                            transform: "translate(-50%, -50%)",
                            width: "1.1rem",
                            height: "2.35rem",
                            padding: 0,
                            marginLeft: "2px",
                            borderRadius: isSnappedRight ? "50% 0 0 50%" : "0 50% 50% 0",
                            border: "0px solid black",
                            backgroundColor: "var(--purple)",
                            color: "white",
                            cursor: "pointer",
                            
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        >
                <Arrow
                    style={{
                    width: "0.6rem",
                    height: "0.6rem",
                    transform: isSnappedRight ? "rotate(0deg)" : "rotate(180deg)"
                    }}
                />
                </button>
                </div>
                )}

                            >
                        <div
                    ref={divRef}
                    style={{
                        minWidth: `${minWidthLeft}em`,
                        width: `${isSnappedRight ? 100 : 100 - prevPane}%`,
                        overflowY: "auto",
                        maxHeight: "100%",
                    }}
                >
                  <ProgressSpinner/>
                </div>

                <div
                    style={{
                        minWidth: `${isSnappedRight ? 0 : 30}rem`,
                        width: `${isSnappedRight ? 0 : prevPane}%`,
                        position: "relative",
                        zIndex: 60,
                        overflowY: "auto",
                        maxHeight: "100%",
                    }}
                >
                    <FilePreview
                        doc={focusedDoc}
                        refresh={docs.fetchData}
                        toggleView={toggleView}
                        onShare={(doc) => setShareDoc(doc)}
                    />
                </div>
                    </Split>
                ) : (
                    <div className={styles.verticalStack}>
                    <div className={styles.flexTable}>{tableBlock}</div>
                    <div className={styles.flexPreview}>
                        <FilePreview
                        doc={focusedDoc}
                        refresh={docs.fetchData}
                        toggleView={toggleView}
                        onShare={(doc) => setShareDoc(doc)}
                        />
                    </div>
                    </div>
                )}
            </section>

            
          </div>)
    }
    else {
        return (
                <div className={styles.wrap}>

                    <header className={styles.topRow}>

                    
                    <div className={styles.heading}>
                        {isMobile && (
                        <button 
                            onClick={onMenuClick} 
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                marginRight: "1rem",
                                marginBottom: "-5rem",
                                width: '28px',
                                height: '28px'
                            }}
                            aria-label="Open navigation menu"
                        >
                            <svg 
                                width="24" 
                                height="24" 
                                viewBox="0 0 24 24" 
                                fill="none" 
                                stroke="var(--primary, #007bff)" 
                                strokeWidth="2.5" 
                                strokeLinecap="round" 
                                strokeLinejoin="round"
                            >
                                <line x1="3" y1="12" x2="21" y2="12"></line>
                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                <line x1="3" y1="18" x2="21" y2="18"></line>
                            </svg>
                        </button>
                    )}

                     {heading}
                    </div>

                    <div className={styles.searchBar}>
                        <SearchBar
                        search={search}
                        setPage={setPage}
                        setSearch={setSearch}
                        />
                    </div>

                    { (
                        <NotificationLogo
                        user={user.pk}
                        display={user.display_notifications}
                        notifications={user.notifications}
                        setShowNotifications={setShowNotifications}
                        />
                    )}

                    
                </header>

                {!isMobile &&(<FilterBar {...filterBarProps} />)}
                {isMobile &&(<MobileFilterBar {...filterBarProps} />)}

                <section className={styles.main}>
                    {isTemplates ? (
                        <div 
                            className={styles.scrollable} 
                            style={{ marginRight: "0.5rem" }}
                            >
                            {tableBlock}
                        </div>
                    ) : isDesktop ? (
                        <Split
                        onDragEnd={handleResize}
                    renderBar={({ onMouseDown, ...props }) => (
            <div
                {...props}
                onMouseDown={onMouseDown}
                style={{
                width: "0.6rem",
                height: "100%",
                backgroundColor: "var(--semilight)",
                cursor: "col-resize",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                zIndex: 70, 
                }}
            >
                <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "2px",
                    height: "100%",
                }}
                >
                <span
                    style={{
                    width: "2px",
                    height: "3rem",
                    backgroundColor: "var(--purple)",
                    borderRadius: "2px",
                    pointerEvents: 'none',
                    }}
                />
                <span
                    style={{
                    width: "2px",
                    height: "3rem",
                    backgroundColor: "var(--purple)",
                    borderRadius: "2px",
                    pointerEvents: 'none',
                    }}
                />
                </div>
                <button
                    onClick={toggleSnapPane}
                    style={{
                        position: "absolute",
                        top: "1.2rem",
                        left: isSnappedRight ? "0" : "100%",
                        transform: "translate(-50%, -50%)",
                        width: "1.1rem",
                        height: "2.35rem",
                        padding: 0,
                        marginLeft: "2px",
                        borderRadius: isSnappedRight ? "50% 0 0 50%" : "0 50% 50% 0",
                        border: "0px solid black",
                        backgroundColor: "var(--purple)",
                        color: "white",
                        cursor: "pointer",
                        
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    >
            <Arrow
                style={{
                width: "0.6rem",
                height: "0.6rem",
                transform: isSnappedRight ? "rotate(0deg)" : "rotate(180deg)"
                }}
            />
            </button>
            </div>
            )}

                        >
                    <div
                ref={divRef}
                style={{
                    minWidth: `${minWidthLeft}em`,
                    width: `${isSnappedRight ? 100 : 100 - prevPane}%`,
                    overflowY: "auto",
                    maxHeight: "100%",
                }}
            >
                {tableBlock}
            </div>

            <div
                style={{
                    minWidth: `${isSnappedRight ? 0 : 30}rem`,
                    width: `${isSnappedRight ? 0 : prevPane}%`,
                    position: "relative",
                    zIndex: 60,
                    overflowY: "auto",
                    maxHeight: "100%",
                }}
            >
                <FilePreview
                    doc={focusedDoc}
                    refresh={docs.fetchData}
                    toggleView={toggleView}
                    onShare={(doc) => setShareDoc(doc)}
                />
            </div>
                </Split>
            ) : (
                <div className={styles.verticalStack}>
                <div className={styles.flexTable}>{tableBlock}</div>
                <div className={styles.flexPreview}>
                    <FilePreview
                    doc={focusedDoc}
                    refresh={docs.fetchData}
                    toggleView={toggleView}
                    onShare={(doc) => setShareDoc(doc)}
                    />
                </div>
                </div>
            )}
        </section>


        {/* Modals */}
        {tableSettingsModal && (
        <TableSettingsModal
            close={toggleTableSettingsModal}
            fields={fields}
            activeFields={activeFields}
            setActiveFields={setActiveFields}
            save={saveAndCloseTableSettingsModal}
        />
        )}
        {shareDoc && (<ShareModal doc={shareDoc} close={() => setShareDoc(null)}/>)}
        {rejectModal && <RejectModal doc={focusedDoc} close={toggleReject} update={update}/>}
        {directRejectModal && <DirectRejectModal user={user} doc={focusedDoc} close={toggleReject} update={update}/>}
        {removeModal && <RemoveModal docs={checkedDocsAsObjects} close={toggleRemove} update={update} user={user.role} hasTemplate={false}/>}
        {captureModal && <CaptureModal docs={[focusedDoc]} close={toggleCapture} update={update}/>}
        {archiveModal && <ArchiveModal doc={focusedDoc} close={toggleArchive} update={update}/>}
        {templateModal && <TemplateModal doc={focusedDoc} close={toggleTemplate} update={update}/>}
        {mergeModal && <MergeModal doc={focusedDoc} docs={docs} selectedDocs={checkedDocs} close={toggleMerge} update={update}/>}
        {viewModal && <FileModal file={focusedDoc?.file_url} close={toggleView}/>}
        {unassignModal && <RemoveAssignedModal doc={focusedDoc} close={toggleUnassign} update={update}/>}
        {exportTableModal && <ExportTableModal close={closeExportTableModal} docs={checkedDocsAsObjects} fields={fields} visibleFields={visibleFields}/>}
        {!!multiDuplicates.length && (
        <DuplicateSModal
            update={fullUpdate}
            duplicates={multiDuplicates}
            setDuplicates={setMultiDuplicates}
        />
        )}
    </div>
    );
}



}